export default __webpack_public_path__ + "static/media/gallery-8.02b6b4bc.jpg";